import * as Inner from './components/engine.css';
export default {
    Inner
};
